import React, { useEffect, useRef } from 'react';
import { useTranslation } from "react-i18next";
import { RESOURCE } from "../../../../const/resource";
import { IProps } from './ordercontactinterface';
import { MaskedTextBox, TextBox } from '@progress/kendo-react-inputs';
import { TreeviewDropdown } from '../../../CommonComponent';
import { Error } from "@progress/kendo-react-labels";

const OrderContact = (props: IProps) => {
    const { t } = useTranslation();
    const orderContactDiv = useRef<any>(null);    

    const phoneInputRef = useRef<any>(null);
    const phoneInputRefText = useRef<any>(null);

    useEffect(() => {
        if (props?.shipmentDetails?.contactPhoneCountryCode && props?.isPhoneUpdated) {
          if(phoneInputRef.current){
            phoneInputRef.current?.focus();
          }
          if (phoneInputRefText?.current) {
            phoneInputRefText.current.element.focus();
          }
        props?.handleIsPhoneUpdated(false);
        }
    }, [props?.shipmentDetails?.contactPhoneCountryCode,props?.isPhoneUpdated]);

    return (
        <div className='ordercontact_wrapper'>
            <div className="shippinginfo_sub-header order" ref={orderContactDiv}> {t(RESOURCE.MyK_Label_ShoppingCart_Order_Contact)}</div>
            <div className="shippingcard">
                <div>
                    <div className='row mb-3'>
                        <div className='col-8 mb-1'>
                            <label>{t(RESOURCE.MyK_Label_ShoppingCart_FC_NameFirstLast)}</label><span className='optionaltext ml-2'>({t(RESOURCE.MyK_Label_ShoppingCart_FC_Optional)})</span>
                       </div>
                        <div className="col-12 col-md-12 col-lg-9 col-xl-8">
                            <input type='text' value={props?.shipmentDetails?.contactName ?? ''}
                                onChange={(e: any) => props?.onInputChange('contactName', e?.target?.value ?? '')}
                                className='textbox' placeholder={t(RESOURCE.MyK_Label_ShoppingCart_FC_EnterName)} />
                       </div>
                    </div>
                </div>
                <div className="row mb-2">
                    <div className="col-md-9 col-lg-9 col-xl-7 col-12">
                        <div className="mb-1">
                            <label>{t(RESOURCE.Myk_Label_Phone)}<span className='optionaltext ml-2'>({t(RESOURCE.MyK_Label_ShoppingCart_FC_Optional)})</span></label>
                        </div>
                        <div className='row'>
                            <div className='col-xl-4 col-lg-3 col-3' ref={props?.refs.contactPhoneCountryCode}>
                                <TreeviewDropdown
                                 onChange={(e: any) => props?.onInputChange('contactPhoneCountryCode', e ?? '')}
                                    value={props?.shipmentDetails?.contactPhoneCountryCode ?? ''}
                                    treeData={props?.phoneCodeOption}
                                    treeNodeFilterProp={"title"}
                                    dropdownClassName={'dropdownListContainer'}
                                    className={'phone'}
                                    showSearch={true}
                                />
                                {(props?.shipmentDetails?.error?.contactPhoneCountryCode) && <Error> {String(t(RESOURCE.MyK_Label_ShoppingCart_FC_PhoneCode_Req))}</Error>}
                            </div>
                            <div className="col-xl-8 col-lg-9 col-9 pl-0" ref={props?.refs.contactPhone}>
                                
                                {(props?.shipmentDetails?.contactPhoneCountryCode == "+1") ?
                                    <MaskedTextBox
                                        onChange={(e: any) => props?.onInputChange('contactPhone', e?.target?.value ?? '')}
                                        value={props?.shipmentDetails?.contactPhone === '(___) ___-____' ? '' : props?.shipmentDetails?.contactPhone}
                                        mask="(999) 000-0000" className='phnumberinput'
                                        ref={phoneInputRef}
                                    /> : <TextBox
                                        onChange={(e: any) => props?.onInputChange('contactPhone', e?.target?.value ?? '')}
                                        value={props?.shipmentDetails?.contactPhone ? props?.getPhoneData(props?.shipmentDetails?.contactPhone) : ''}
                                        className='phnumberinput'
                                        maxLength={15}
                                        ref={phoneInputRefText}
                                    />}
                                {(props?.shipmentDetails?.error?.contactPhone) && <Error> {String(t(RESOURCE.MyK_Label_ShoppingCart_Phone_Req))}</Error>}
                                {(props?.shipmentDetails?.error?.isInvalidPhone) && <Error> {String(t(RESOURCE.MyK_Label_ShoppingCart_Phone_Invalid))}</Error>}
                        </div>
                        </div>
                    </div>
                </div>
               
            </div>
        </div>
    )
}

export default OrderContact